module.exports = __webpack_public_path__ + "assets/c4f713750d889704ee04e1a64f95eca5.png";